import map from "lodash/map";

export const fixQuill = (text) => {
    const pTagRegex = /(<p><br><\/p>)/ig;
    return text?.replace(pTagRegex, "") || "";
};

export const convertReturnsToHTML = (text) => {
    const returnNRegex = /(\n)/ig;
    return `<p>${text.replace(returnNRegex, "<br />")}</p>`;
};

export const charLimit = (text, maxLength, isHTML) => {
    if ((text || "").length > maxLength) {
        if(!isHTML) {
            return `${text.substring(0, maxLength - 1)}…`;
        }

        // isHTML
        let mention = text.indexOf("class=\"mention\"");
        let totalMaxLength = maxLength;
        if(mention > -1 && mention < maxLength) {
            // there is a mention in the first 200 characters, add more to get past the crazy HTML
            totalMaxLength = maxLength + 275;
        }

        // Return all if it's less than max
        if(totalMaxLength >= text.length) {
            return text;
        }

        // If there's not a </p> tag, just return the max
        let pIndex = text.indexOf("</p>");
        if(pIndex < 0) {
            return `${text.substring(0, totalMaxLength - 1)}…`;
        }

        // Loop through looking for all </p> and stop once it's past totalMaxLength
        let lastIndex = pIndex;
        while(lastIndex < totalMaxLength ) {
            pIndex = text.substring(lastIndex+5).indexOf("</p>");
            if(pIndex < 0) {
                // No more matches
                break;
            }

            // Update the last index
            lastIndex = lastIndex + 5 + pIndex;
        }

        if(lastIndex > totalMaxLength + 20) {
            return `${text.substring(0, totalMaxLength - 1)}…</p>`;
        } else {
            return `${text.substring(0, lastIndex)}…</p>`;
        }
    }

    return text;
}

export const shortenFilename = (filename, maxLength) => {
    if(!filename) {
        return "";
    }
    const parts = filename.split(".");
    const shortened = charLimit(parts[0], maxLength-4, false);
    return `${shortened}.${parts[1]}`;
}

export const isValidEmailAddress = (email="") => {
    const format1 = /^[ A-Za-z0-9_@./#&+-]*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    const format2 = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    return format1 || format2;
}

export const getOptions = (collection) => {
    return map(collection, item => {
        return {
            name: item.name,
            value: item.id,
        };
    });
};

export const convertStripePrice = (price) => {
    return`$${Math.abs(price / 100).toFixed(2)}`
}